import { IntlShape } from "react-intl"

export interface PharmacyInfo {
  fertilityPharmacy: string
  isCarrotRxActive: boolean
  isCarrotRxRequired: boolean
}

export interface PharmacyTextResult {
  label: string
  value: string
  linkText?: string
  nonLinkText?: string
  url?: string
  phoneNumber?: string
}

function getPharmacyText(
  pharmacyInfo: PharmacyInfo,
  intl: IntlShape
): {
  linkText?: string
  nonLinkText: string
  url?: string
  phoneNumber?: string
} {
  if (!pharmacyInfo.isCarrotRxActive)
    return { nonLinkText: intl.formatMessage({ defaultMessage: "Ask member preference" }) }
  const preference = pharmacyInfo.isCarrotRxRequired
    ? intl.formatMessage({ defaultMessage: "required" })
    : intl.formatMessage({ defaultMessage: "preferred" })

  const capitalizedPharmacy = pharmacyInfo.fertilityPharmacy
    ? pharmacyInfo.fertilityPharmacy.charAt(0).toUpperCase() + pharmacyInfo.fertilityPharmacy.slice(1).toLowerCase()
    : ""

  // Matched against the raw CarrotRxPharmacy value rather than the rendered label, so the support
  // phone number and the Freedom Fertility carve-out survive the FBEP-664 rebrand.
  const pharmacyValue = pharmacyInfo.fertilityPharmacy?.toUpperCase() ?? ""
  const isAlto = pharmacyValue.includes("ALTO")
  const isFreedomFertility = pharmacyValue.includes("FREEDOM_FERTILITY")

  const pharmacyName = isAlto ? "FuzeRx" : capitalizedPharmacy
  const shouldShowPharmacyName = pharmacyInfo.fertilityPharmacy && !isFreedomFertility
  const phoneNumber = isAlto ? "(844) 725-0001" : undefined

  return {
    linkText: intl.formatMessage({ defaultMessage: "Carrot Rx" }),
    nonLinkText: shouldShowPharmacyName ? ` (${pharmacyName}) ${preference}` : ` ${preference}`,
    url: "https://app.get-carrot.com/your-benefit-guide/pharmacy",
    phoneNumber
  }
}

export function createPharmacyCardItem(pharmacyInfo: PharmacyInfo, label: string, intl: IntlShape): PharmacyTextResult {
  const pharmacyData = getPharmacyText(pharmacyInfo, intl)
  return {
    label,
    value: `${pharmacyData.linkText || ""}${pharmacyData.nonLinkText}`,
    linkText: pharmacyData.linkText,
    nonLinkText: pharmacyData.nonLinkText,
    url: pharmacyData.url,
    phoneNumber: pharmacyData.phoneNumber
  }
}
